<template lang="pug">

  MDashboardWidget( v-if="! $apollo.loading" title="Link Audits Completed" )
    table( class="table-hover no-margins" )
      thead
      th
        th This Month
          th Last Month
          
      tbody
        tr
          td Company
          td {{ company.numAudits }}
          td 200
        tr
          td me
          td 100
          td 200
      tfoot
        tr 
          th Our Monthly Allowance:
          th( colspan="2" ) 1000 links resets 23rd of the month

</template>

<script>
import gql from 'graphql-tag'
import Vue from 'vue'
export default Vue.extend({

  data() {
    return {
      me: {
        thisMonth: 400,
        lastMonth: 200
      }
    }
  },

  apollo: {
    
    company: {
      query: gql`query ($id: ID!) {
        companyById(id: $id) {
          numAudits
          remainingAudits
          numMonthlyLinks
        }
      }`,
      variables() {
        return {
          id: this.$moonpull.getCurrentUserSession().company.id
        }
      },
      update: data => data.companyById
    }

  },

})
</script>
